import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const menuItems = [{
    label: 'Masterclasses',
    href: '#masterclasses'
  }, {
    label: 'Private Classes',
    href: '#private'
  }, {
    label: 'Makeup Services',
    href: '#services'
  }, {
    label: 'About',
    href: '#founder'
  }, {
    label: 'FAQs',
    href: '#faqs'
  }];
  const customEase = [0.16, 1, 0.3, 1];
  return <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-white/90 backdrop-blur-md border-b border-cream-dark py-4' : 'bg-transparent py-6'}`} data-id="element-292">
        <div className="max-w-[90rem] mx-auto px-6 lg:px-12 flex items-center justify-between" data-id="element-293">
          {/* Logo */}
          <a href="#home" className="font-serif text-2xl md:text-3xl font-light tracking-wide text-ink relative z-50" data-id="element-294">
            The Makeup Atelier
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-10" data-id="element-295">
            {menuItems.map(item => <a key={item.label} href={item.href} className="font-sans text-xs uppercase tracking-[0.2em] text-stone hover:text-ink transition-colors duration-300" data-id="element-296">
                {item.label}
              </a>)}
            <a href="#masterclasses" className="bg-ink text-parchment px-8 py-3 font-sans text-xs uppercase tracking-[0.2em] hover:bg-espresso transition-colors duration-300" data-id="element-297">
              Book a Masterclass
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden relative z-50 w-8 h-8 flex flex-col justify-center items-center gap-1.5" aria-label="Toggle menu" data-id="element-298">
            <span className={`block w-6 h-[1px] bg-ink transition-transform duration-500 ${isMobileMenuOpen ? 'rotate-45 translate-y-[7px]' : ''}`} data-id="element-299" />
            <span className={`block w-6 h-[1px] bg-ink transition-opacity duration-500 ${isMobileMenuOpen ? 'opacity-0' : 'opacity-100'}`} data-id="element-300" />
            <span className={`block w-6 h-[1px] bg-ink transition-transform duration-500 ${isMobileMenuOpen ? '-rotate-45 -translate-y-[7px]' : ''}`} data-id="element-301" />
          </button>
        </div>
      </nav>

      {/* Full Screen Mobile Menu */}
      <AnimatePresence data-id="element-302">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.6,
        ease: customEase
      }} className="fixed inset-0 z-40 bg-parchment flex flex-col items-center justify-center px-6" data-id="element-303">
            <div className="flex flex-col items-center space-y-8 text-center" data-id="element-304">
              {menuItems.map((item, i) => <motion.a key={item.label} href={item.href} onClick={() => setIsMobileMenuOpen(false)} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: i * 0.1,
            duration: 0.6,
            ease: customEase
          }} className="font-serif text-4xl font-light text-ink hover:text-copper transition-colors" data-id="element-305">
                  {item.label}
                </motion.a>)}
              <motion.a href="#masterclasses" onClick={() => setIsMobileMenuOpen(false)} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: menuItems.length * 0.1,
            duration: 0.6,
            ease: customEase
          }} className="mt-8 bg-ink text-parchment px-10 py-4 font-sans text-xs uppercase tracking-[0.2em]" data-id="element-306">
                Book a Masterclass
              </motion.a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}